import { defineMessages } from 'react-intl-next';

const messages: {
	approvals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	home: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requests: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	home: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.home.non-final',
		defaultMessage: 'Home',
		description: 'Navigation link label for the home page',
	},
	requests: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.requests.non-final',
		defaultMessage: 'Requests',
		description: 'Navigation link label for user requests',
	},
	approvals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.approvals.non-final',
		defaultMessage: 'Approvals',
		description: 'Navigation link label for user approvals',
	},
});

export default messages;
